import { SortEvent } from 'primeng/api';

export function globalSortFunction<T>(event: SortEvent, numericFields: (keyof T)[]): void {
  const field = event.field as keyof T;
  const order = event.order;

  if (event.data && field && order) {
    event.data.sort((a: T, b: T) => {
      const value1 = a[field];
      const value2 = b[field];

      // If the field is numeric but has a prefix
      if (numericFields.includes(field)) {
        const num1 = extractNumericSuffix(value1);
        const num2 = extractNumericSuffix(value2);
        if (num1 !== null && num2 !== null) {
          return (num1 - num2) * order;
        }
      }

      // Sort as string if not numeric
      const strValue1 = value1 == null ? '' : value1.toString();
      const strValue2 = value2 == null ? '' : value2.toString();
      return strValue1.localeCompare(strValue2) * order;
    });
  }
}

// Extracts the number at the end of the string;
function extractNumericSuffix(value: unknown): number | null {
  if (typeof value === 'string') {
    const match = value.match(/(\d+)$/);
    if (match) {
      return Number(match[1]);
    }
  } else if (typeof value === 'number') {
    return value;
  }
  return null;
}
